import React from "react";
import ReactDOM from "react-dom";
import App from './App';
import {initializeApp} from 'firebase/app';
import {firebaseConstants} from "./util/Constants";

import "assets/plugins/nucleo/css/nucleo.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/scss/argon-dashboard-react.scss";
import "assets/css/styles.css";
import "react-loading-skeleton/dist/skeleton.css";
import {BrowserRouter} from "react-router-dom";

// Initialize Firebase
const app = initializeApp(firebaseConstants.firebaseConfig);
// console.log(app.name);

ReactDOM.render(
    <BrowserRouter>
        <App/>
    </BrowserRouter>,
    document.getElementById("root")
);
